import { PersistenceService } from '~/shared/services/persistence.service';
import { ActionReducer, MetaReducer } from '@ngrx/store';
import { State } from '~/modules';

let isStoreReady = false;
export const persistenceMetaReducerFactory =
  (persistenceService: PersistenceService): MetaReducer<State> =>
  (reducer: ActionReducer<State>) =>
  (stateBefore, action) => {
    if (action.type === '@ngrx/store/init') {
      isStoreReady = true;
    }
    if (!isStoreReady) {
      return reducer(stateBefore, action);
    }
    return reducer(persistenceService.syncState(stateBefore), action);
  };
